import React from 'react';

import PdfContext from './Pdf/PdfContext';
import Viewer from './Pdf/Viewer';

const SCALE_LEVEL = {
  MIN: 0.8,
  MAX: 2,
};

export default class Pdf extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: 0.8,
    };
  }

  zoomIn = () => {
    this.setState({ scale: Math.min(this.state.scale + 0.4, SCALE_LEVEL.MAX) });
  };

  zoomOut = () => {
    this.setState({ scale: Math.max(this.state.scale - 0.4, SCALE_LEVEL.MIN) });
  };

  render() {
    const { file, page, index, shownIndex } = this.props;
    let caption;

    return (
      <PdfContext file={file} page={page} scale={this.state.scale}>
        <Viewer />

        <div class="tool-bar">
          {shownIndex && <div class="index-indicator">{index}</div>}
          {caption}
          <div class="button-group">
            <div class="zoom-out button" onClick={this.zoomOut} />
            <div class="zoom-in button" onClick={this.zoomIn} />
          </div>
        </div>
      </PdfContext>
    );
  }
}
